<template>
    <iframe-group>
        <template v-slot:meta>
			<v-col cols="12">
				<v-text-field v-model="mValue.Title" label="Title"></v-text-field>
			</v-col>
			<v-col cols="12" sm="4" md="3" lg="2" class="d-flex">
				<NumberColumnsTextField v-model="mValue.NumColumns" label="Number of Columns" :tooltip="numColumnsTooltip" />
			</v-col>
        </template>

        <template v-slot:Iframes>
			<DraggableGroupItems
				v-model="mValue.Iframes"
				items-label="Iframe"
				:items-style="itemsStyle"
				class="full-width"
				@add-item="addItem"
				@delete-item="deleteItem"
			>
				<template v-slot:default="{ item }">
					<text-editor v-model="item.pretext"></text-editor>
					<div class="iframe-container">
                        <iframe class="responsive-iframe" :src="item.src"></iframe>
                    </div>
					<v-text-field label="Source" v-model="item.src"></v-text-field>
					<text-editor v-model="item.text"></text-editor>
				</template>
			</DraggableGroupItems>
        </template>
    </iframe-group>
</template>

<script>
import TextEditor from '../TextEditor.vue'
import IframeGroup from '@/CMS/views/ContentBlocks/IframeGroup.vue'
import NumberColumnsTextField from '@/CMS/editor/components/NumberColumnsTextField.vue'
import DraggableGroupItems from '@/CMS/editor/components/DraggableGroupItems.vue'
import { CmsGroupEditorMixin } from '@/CMS/mixins/CmsGroupMixin'

export default {
    components: {
        TextEditor,
        IframeGroup,
		NumberColumnsTextField,
		DraggableGroupItems,
    },
	mixins: [CmsGroupEditorMixin],
    props: {
		value: { type: Object },
	},
    data () {
        return {
			itemsName: 'Iframes', // override Mixin
        }
    },
    methods: {
		reset () { // override Mixin
			const value = { ...this.mValue }
			if (typeof value.Iframes === 'undefined') {
				value.Iframes = [this.getNewItem()]
			}
			if (typeof value.NumColumns === 'undefined') {
				value.NumColumns = 4
			}
			value.Iframes.map((iframe) => {
				const item = { ...iframe }
				if (typeof item.id === 'undefined') {
					this.counter = this.counter + 1
					item.id = this.counter
				}
				return item
			})
			this.mValue = value
		},
		getNewItem () { // override Mixin
			this.counter = this.counter + 1
			return {
				id: this.counter,
				title: '',
                pretext: '<h3>Title</h3>',
                src: 'https://www.quility.com',
                text: '<p>Some other optional text.</p>',
			}
		},
    },
}
</script>
